<template>
  <div v-loading="loading || proReportDataLoading" element-loading-spinner="atom-audit-loader" style="min-height: 425px;">
    <PROSummary :ref="`proSummary_${item.codeDesc}`" v-for="item in tableData" :title="item.codeDesc" :key="item.codeNumber" :item="item" @handleTableCommands="handleTableCommands"></PROSummary>
    <center v-if="!loading">
      <div class="no-data-message" v-if="tableData.length === 0">No Summary Data Available</div>
    </center>
  </div>
</template>

<script>
  import { mapState } from 'vuex'
  import axios from '@/utilities/axios-global'
  import hiaFilters from '@/mixins/hiaFilters'

  import dashboardHelper from '@/mixins/dashboardHelper'
  import PROSummary from './PRO_Summary'
  export default {
    name: 'PRO_BasicSummary',
    mixins: [hiaFilters, dashboardHelper],
    components: {
      PROSummary
    },
    props: ['proRecordIds', 'codeTypes'],
    data: function() {
      return {
        tableData: [],
        filterCriteria: '',
        loading: false
      }
    },
    methods: {
      async getData() {
        const payload = {
          proRecordIds: this.proRecordIds,
          includeAccts: false,
          statType: 'test',
          codeTypes: this.codeTypes
        }
        try {
          this.loading = true
          const response = await axios.post(this.baseApiUrl + '/reports/dashboard/proBasicStat', payload)
          this.tableData = response.data
        } catch (err) {
          this.tableData = []
          this.allData = []
        } finally {
          this.loading = false
        }
      },
      handleTableCommands(command) {
        this.$emit('handleTableCommands', command)
      }
    },
    computed: {
      ...mapState('user/', ['baseApiUrl']),
      ...mapState('reports/', ['proReportDataLoading'])
    },
    mounted: async function() {
      await this.getData()
    },
    activated: async function() {
      await this.getData()
    },
    watch: {
      proRecordIds: async function() {
        await this.getData()
      },
      codeTypes: async function() {
        await this.getData()
      }
    }
  }
</script>

<style scoped></style>
